let currentX = 0, currentY = 0;
let isDragging = false;
let startX = 0, startY = 0;
let scale = 1; // 缩放比例
const MIN_SCALE = 0.5; // 最小缩放
const MAX_SCALE = 3;   // 最大缩放
let previewWrap = null;

// 创建预览容器 + 图片 + 关闭按钮
function createPreview(url) {
  destroyPreview();

  const wrap = document.createElement('div');
  wrap.id = 'preview-wrap';
  wrap.style.cssText = `
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(1);
    transform-origin: center center;
    z-index: 999999;
    cursor: move;
    user-select: none;
    touch-action: none;
  `;
  document.body.appendChild(wrap);
  previewWrap = wrap;

  const img = document.createElement('img');
  img.src = url;
  img.style.cssText = `
    display: block;
    max-width: 30vw;
    max-height: 50vh;
    object-fit: contain;
  `;
  wrap.appendChild(img);

  // 关闭按钮（跟随图片）
  const closeBtn = document.createElement('div');
  closeBtn.innerHTML = '✕';
  closeBtn.style.cssText = `
    position: absolute;
    right: -12px;
    top: -12px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(0,0,0,0.75);
    color: #fff;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    z-index: 10;
  `;
  wrap.appendChild(closeBtn);
  closeBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    destroyPreview();
  });

  currentX = 0;
  currentY = 0;
  scale = 1;
  bindDrag(wrap);
  bindWheel(wrap); // 绑定滚轮缩放
}

// 滚轮缩放（鼠标指向哪，从哪放大缩小）
function bindWheel(el) {
  el.addEventListener('wheel', (e) => {
    e.preventDefault();

    const newScale = scale + (e.deltaY > 0 ? -0.1 : 0.1);
    scale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, newScale));

    el.style.transform = `
      translate(-50%, -50%)
      translate(${currentX}px, ${currentY}px)
      scale(${scale})
    `;
  });
}

// 拖拽
function bindDrag(el) {
  el.addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.clientX;
    startY = e.clientY;
    e.preventDefault();
  });
  el.addEventListener('touchstart', (e) => {
    isDragging = true;
    const t = e.touches[0];
    startX = t.clientX;
    startY = t.clientY;
    e.preventDefault();
  });

  function onMove(e) {
    if (!isDragging) return;
    let x, y;
    if (e.type === 'mousemove') {
      x = e.clientX; y = e.clientY;
    } else {
      const t = e.touches[0];
      x = t.clientX; y = t.clientY;
    }
    const dx = x - startX;
    const dy = y - startY;
    startX = x; startY = y;
    currentX += dx; currentY += dy;

    el.style.transform = `
      translate(-50%, -50%)
      translate(${currentX}px, ${currentY}px)
      scale(${scale})
    `;
  }

  function onEnd() {
    isDragging = false;
  }

  document.addEventListener('mousemove', onMove);
  document.addEventListener('mouseup', onEnd);
  document.addEventListener('touchmove', onMove, { passive: false });
  document.addEventListener('touchend', onEnd);

  el.addEventListener('click', (e) => e.stopPropagation());
  document.body.addEventListener('click', destroyPreview);
}

function destroyPreview() {
  if (previewWrap) {
    previewWrap.remove();
    previewWrap = null;
  }
  currentX = 0; currentY = 0; scale = 1;
}



// 监听来自 iframe 的消息
function initPreviewRoot() {
    window.addEventListener('message', (e) => {
        // 可加 origin 白名单更安全
        if (e.data?.type === 'preview-image') {
            createPreview(e.data.url);
        }
        if (e.data?.type === 'close-preview') {
            destroyPreview();
        }
    });
}
export default initPreviewRoot;